module.exports = __webpack_public_path__ + "img/folder.85bd340f.svg";